import { withInstall } from '@vuesax-plus/utils'
import close from './src/close.vue'

export const IconClose = withInstall(close)
export default IconClose

export * from './src/close'
